(ns app.front.view.whats-coming
  (:require [app.front.ui :as ui]
            [app.front.ui.v2.dialog :as dialog]
            [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

(def ^:const content-version "v2")

(def ^:private local-storage-key "whats-coming-version-seen")

(defn- enabled? []
  (ff/enabled? :feature-flag.id/upcoming-changes-modal))

(def ^:private bullet-keys
  [[:whats-coming/bullet-1-title :whats-coming/bullet-1-text]
   [:whats-coming/bullet-2-title :whats-coming/bullet-2-text]
   [:whats-coming/bullet-3-title :whats-coming/bullet-3-text]
   [:whats-coming/bullet-4-title :whats-coming/bullet-4-text]])

(def ^:private features
  [{:img "/asset/img/application-wizard-summary.png"}])

;; -- State -------------------------------------------------------------------

;; Fully-qualified keyword from app.front.view.login, referenced directly to
;; avoid a circular require. It is true while the landing-page sign-in overlay
;; (the application-process login flow) is open.
(def ^:private sign-in-overlay-open-key
  :app.front.view.login/sign-in-overlay-open?)

(rf/reg-sub ::modal-open?
  (fn [db _] (get db ::modal-open? false)))

(rf/reg-sub ::page
  (fn [db _] (get db ::page 0)))

(rf/reg-sub ::dont-show-again?
  (fn [db _] (get db ::dont-show-again? false)))

(rf/reg-event-db ::open
  (fn [db _]
    (if (enabled?)
      (assoc db ::modal-open? true ::page 0 ::dont-show-again? false)
      db)))

(rf/reg-event-db ::set-dont-show-again
  (fn [db [_ checked?]]
    (assoc db ::dont-show-again? (boolean checked?))))

(rf/reg-event-fx ::close
  (fn [{:keys [db]} _]
    (when (::dont-show-again? db)
      (futil/local-storage-set! local-storage-key content-version))
    {:db       (dissoc db ::modal-open? ::page ::dont-show-again?)
     :dispatch [:app.front.root/flash-whats-coming-cta]}))

(rf/reg-event-fx ::check-and-open
  (fn [{:keys [db]} _]
    (when (and (enabled?)
               (not (get db sign-in-overlay-open-key))
               (not= content-version (futil/local-storage-get local-storage-key)))
      {:dispatch [::open]})))

(rf/reg-event-db ::prev
  (fn [db _]
    (update db ::page #(max 0 (dec (or % 0))))))

(rf/reg-event-db ::next
  (fn [db _]
    (let [next-page (inc (get db ::page 0))]
      (if (< next-page (count features))
        (assoc db ::page next-page)
        db))))

;; -- View --------------------------------------------------------------------

(defn whats-coming-modal [tr]
  (when (enabled?)
    (let [open?            (<sub [::modal-open?])
          current          (<sub [::page])
          dont-show-again? (<sub [::dont-show-again?])
          page-count       (count features)
          first?           (zero? current)
          last?            (= current (dec page-count))
          {:keys [img]}    (nth features current)]
      [dialog/dialog
       {:open?       open?
        :on-close    #(>evt [::close])
        :class       "max-w-lg rounded-md"
        :aria-label  (tr [:whats-coming/title])
        :close-label (tr [:close])
        :data-cy     "whats-coming-modal"
        :header      [:div
                      [:h2.font-semibold.text-2xl.pb-2.text-ui-night-sky-100 (tr [:whats-coming/title])]
                      [:p.py-0.text-sm.text-ui-night-sky-100 (tr [:whats-coming/description])]
                      [:p.pt-3.text-sm.font-semibold.text-ui-night-sky-100 (tr [:whats-coming/list-heading])]
                      [:ul.list-disc.pl-5.mt-1.mb-0.text-sm.text-ui-night-sky-100.space-y-1
                       (futil/for-frag [[title-key text-key] bullet-keys]
                         [:li
                          [:span.font-semibold (tr [title-key])]
                          " — "
                          (tr [text-key])])]]
        :body        [:div.mt-2
                      [:hr]
                      [:div.mt-4.px-8.py-2
                       [:img {:src   img
                              :alt   (tr [:whats-coming/image-alt])
                              :class "block w-full h-auto"}]]
                      [:hr]]
        :footer      [:div.flex.flex-col.gap-3.w-full
                      [:div.flex.justify-start
                       (cc/checkbox {:id         "whats-coming-dont-show-again"
                                     :label-text (tr [:whats-coming/dont-show-again])
                                     :checked    dont-show-again?
                                     :data-cy    "whats-coming-dont-show-again"
                                     :on-change  #(>evt [::set-dont-show-again (not dont-show-again?)])})]
                      [:div.flex.items-center.justify-between.w-full.gap-4
                       [:div.flex.flex-1.justify-start
                        (when-not first?
                          [ui/button {:kind     :secondary
                                      :on-click #(>evt [::prev])
                                      :size     :small}
                           (tr [:whats-coming/previous])])]

                       [:span.shrink-0.text-sm.text-gray-500
                        (str (inc current) " " (tr [:whats-coming/of]) " " page-count)]

                       [:div.flex.flex-1.justify-end
                        (if last?
                          [ui/button {:kind     :ghost
                                      :on-click #(>evt [::close])
                                      :size     :small}
                           (tr [:whats-coming/close])]
                          [ui/button {:kind     :secondary
                                      :on-click #(>evt [::next])
                                      :size     :small}
                           (tr [:whats-coming/next])])]]]}])))
